<!--
Modal component with customizable slots and CSS transitions.
-->

<script>
import clientInfoModal from './clientInfoModalContent.vue'

export default {
  name: 'clientInfoButtonAndModal',
  components: {
    clientInfoModal
  },
  props: ['clientid','clientname', 'contactfirstname', 'contactlastname', "contactmail", "logo" , 'type', 'routesubmit'],
  data() {
    return {
      showModal: false,
      typeicone: "",
      classicone: "",
    }
  },
  mounted() {
    if(this.type == "new") {
      this.classicone = "buttonOriginal";
      this.typeicone = "glyphicon glyphicon-plus";
    } else {
      this.classicone = "info-button";
      this.typeicone = "glyphicon glyphicon-info-sign";
    }
  },
  methods: {
    afficheModal() {
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    }
  }
}
</script>

<template>
  <div>
    <button id="show-modal" :class="this.classicone" @click="afficheModal"><span :class="this.typeicone" :title="trans.get('common.infocustomer')"></span></button>
  
    <!-- use the modal component, pass in the prop -->
    <clientInfoModal v-if="showModal" @close="closeModal" :clientid="this.clientid" :clientname="this.clientname" :contactfirstname="this.contactfirstname" :contactlastname="this.contactlastname"  :contactmail="this.contactmail" :logo="this.logo" :routesubmit="this.routesubmit"></clientInfoModal>
  </div>
</template>